import { Injectable } from '@angular/core';
import { SelectItemV2, UnitsV2 } from '@schenck/rotec-components';
import { RotorTypeConfiguration } from 'src/utils/constants/rotor-type.const';
import { GeometryTypes, RotorTypeCreationRequestTypes } from 'src/utils/enums/rotor-type.enum';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import {
  CorrectionGeometryPlane,
  PedestalPlane,
  PlaneGeometry,
} from 'src/utils/interfaces/rotor-type.interfaces';
import { mapToCorrectionGeometryPlane, mapToRotorTypeValue } from './adapter.mappers';

export class PlaneGeometryModel implements PlaneGeometry {
  constructor(
    public readonly $type: string,
    public readonly correctionPlanes: CorrectionGeometryPlane,
    public readonly pedestalPlanes?: PedestalPlane[]
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class PlaneGeometryAdapter implements Adapter<RotorTypeFormsData, PlaneGeometry> {
  /**
   * Creates the adapted form data for plane geometry field
   *
   * @param formData: RotorTypeFormsData
   * @param units: UnitsV2[]
   * @returns PlaneGeometry
   */
  public adapt(
    { rotorTypeSettingsStep, supportSettingsStep }: RotorTypeFormsData,
    units: UnitsV2[]
  ): PlaneGeometry {
    const { a, b, c, r1, r2, pedestalPosition1, pedestalPosition2 } = rotorTypeSettingsStep;
    const supportCase: SelectItemV2 = {
      name: GeometryTypes.supportCase,
      value: supportSettingsStep.selectedCorrectionPlane
        ? RotorTypeConfiguration[supportSettingsStep.selectedCorrectionPlane - 1].index
        : null,
    };
    const geometry = { a, b, c, r1, r2, supportCase };
    const correctionPlanes = Object.entries(geometry).filter(([_, value]) => value);
    const pedestalPlanes = pedestalPosition1
      ? Object.entries({ pedestalPosition1, pedestalPosition2 })
      : [];

    return new PlaneGeometryModel(
      RotorTypeCreationRequestTypes.PlaneGeometry,
      mapToCorrectionGeometryPlane(correctionPlanes, units),
      pedestalPlanes.map(([_, value], index) => ({
        planeIndex: index,
        distance: mapToRotorTypeValue(value, units),
      }))
    );
  }
}
